import { useNavigation } from "@react-navigation/native"
import { useEffect } from "react"

export const useHasFinishedFastTrack = (hasFinishedFastTrack, emailB64) => {
    const navigation = useNavigation()
    useEffect(() => {
        if (hasFinishedFastTrack) {
            navigation.navigate("register/fast-track/thank-you", {
                user: emailB64,
            })
        }
    }, [hasFinishedFastTrack])
}
